import React from 'react';
import ConditionPage from '../components/ConditionPage';

const Oncology: React.FC = () => (
  <ConditionPage
    eyebrow="Cancer care"
    docTitle="Cancer care — Haven Crest Health"
    title={<>Every scan, every note, <em>in one place.</em></>}
    lede="Cancer care generates more records than almost anything else: pathology, imaging, infusion notes, scans from three different systems. Haven Crest pulls all of it into your own inbox with one-click requests we send on your behalf, then helps you read it, get a second opinion, and find the right specialist. Free, and entirely your choice."
    items={[
      { icon: '🧫', title: 'Pathology and staging', text: 'Request the biopsy report and staging notes directly, and get a plain-language summary of what they say.' },
      { icon: '🩻', title: 'Imaging from every system', text: 'CTs, PETs, and MRIs often live in different portals. One click each, and they arrive together.' },
      { icon: '↔', title: 'Second opinions', text: 'With the full file in hand, a navigator helps you find a specialist and share the records before the visit.' },
      { icon: '📅', title: 'Treatment timeline', text: 'Infusion records and visit notes in date order, so you and any new doctor can see the whole course.' },
    ]}
  />
);

export default Oncology;
